require('./brokerMyInvestmentsProductsTable.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const Immutable = require('immutable');
const { connect } = require('react-redux');

// @components
const { BrokerMyInvestmentsProductsRow } = require('../brokerMyInvestmentsProductsRow/brokerMyInvestmentsProductsRow');

//@ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @actions
const BrokerStocksSellActions = require('actions/brokerStocksSell');
const BrokerInternalTransferFundsActions = require('actions/brokerInternalTransferFunds');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    TYPE_OTHERS,
    TYPE_MIXTOS,
} = require('constants/index');


const typeMatches = {
    ACCIONES: 'stocks',
    ETF: 'etfs',
    WARRANTS: 'warrants',
    OTROS: 'others',
    DERECHOS: 'derechos'
};

class BrokerMyInvestmentsProductsTable extends React.Component {
    buildTooltipContentRow() {
        const title = formatText('broker-investmentsmixtosTableTitle');
        const content = formatText('broker-mixitosAssetTooltip');
        const iconInfo =(
            <OKTooltip
                content={content}
                placement="right"
            />

        );
        return (
            <OKTableRow className="broker-products-table-row">
                <OKTableCell>
                    <span className="broker-assets-table-others__tooltip-title">
                        {title}
                    </span>
                    {iconInfo}
                </OKTableCell>
            </OKTableRow>
        );
    }

    render() {
        const {
            immStocks,
            immFundsContributionsList,
            type,
            showCompleteList,
            immMyInvestments,
            setSellContract,
            isContractSection,
            onHandleBuyClick,
            onPreSelectOriginInternalTransferFund
         } = this.props;
        const immList = !showCompleteList ? immStocks.slice(0, 5) : immStocks;

        const immSortedList = immList.sort(immStock => {
            const productType = immStock.get('productType');
            const finalType = typeMatches[productType] ? typeMatches[productType] : type;
            return finalType === TYPE_OTHERS ? 1 : 0;
        });

        const tableRows = immSortedList.map((immStock, index) => {
            return (<BrokerMyInvestmentsProductsRow
                key={index}
                immStock={immStock}
                immFundsContributionsList={immFundsContributionsList}
                immMyInvestments={immMyInvestments}
                type={type}
                setSellContract={setSellContract}
                isContractSection={isContractSection}
                onHandleBuyClick={onHandleBuyClick}
                onPreSelectOriginInternalTransferFund={onPreSelectOriginInternalTransferFund}
                pageName={this.props.pageName}
             />);
        });

        let tooltip;
        if(type ==  TYPE_MIXTOS){
            tooltip = this.buildTooltipContentRow();
        }

        return (
            <tbody>
                {tooltip}
                {tableRows}
            </tbody>
         );
    }
}

BrokerMyInvestmentsProductsTable.propTypes = {
    immStocks: PropTypes.object,
    immMyInvestments: PropTypes.object,
    type: PropTypes.string,
    showCompleteList: PropTypes.bool,
    setSellContract: PropTypes.func.isRequired,
    isContractSection: PropTypes.bool,
    onHandleBuyClick: PropTypes.func,
    onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
    pageName: PropTypes.string
};

BrokerMyInvestmentsProductsTable.defaultProps = {
    immStocks: Immutable.List(),
    showCompleteList: false
};

module.exports.constructor = BrokerMyInvestmentsProductsTable;
module.exports.BrokerMyInvestmentsProductsTable = connect(
    state => ({
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        setSellContract: BrokerStocksSellActions.setSellContract,
        onPreSelectOriginInternalTransferFund: BrokerInternalTransferFundsActions.preSelectOrigin
    }
)(BrokerMyInvestmentsProductsTable);
